import React, {Fragment, useState, SyntheticEvent} from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Button from '@mui/material/Button';
import Paper from "@mui/material/Paper";
import TableBody from "@mui/material/TableBody";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableContainer from "@mui/material/TableContainer";
import Stack from '@mui/material/Stack';
import {styled} from '@mui/material/styles';
import AddIcon from "@mui/icons-material/Add";
import {s_char, s_char_disciplines} from "../../_signals/s_char";
import {useSignals} from "@preact/signals-react/runtime";
import {ICharDiscipline} from "../../_interfaces/ICharDiscipline";
import DisziplinesAdd from "./DisziplinesAdd";
import DisziplinesEdit from "./DisziplinesEdit";
import EditIcon from "@mui/icons-material/Edit";
import CasinoIcon from "@mui/icons-material/Casino";
import ccAttribute from "../../_helper/ccAttribute";
import {s_char_attr_step} from "../../_signals/s_char_attr";
import {
    s_char_mods_cha,
    s_char_mods_ges,
    s_char_mods_str,
    s_char_mods_wah, s_char_mods_wil,
    s_char_mods_zae
} from "../../_signals/s_char_mods";
import {IRollerRoll} from "../../_interfaces/IRoller";
import {rollerSetRoll} from "../../_helper/rollBehave";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import {FormControl, InputLabel, MenuItem, Select} from "@mui/material";
import CharCreate from "../../_helper/charcreate";
import {v4} from "uuid/wrapper.mjs";
import CasinoOutlinedIcon from "@mui/icons-material/CasinoOutlined";
import disziplinen from "../../_data/disziplinen";
import {DisciplinesSubscriber} from "../../_helper/DataBehaves";
import {InfoDisciplineBehaveSubscriber} from "../../_helper/InfoDisciplineBehave"
import HelpOutlineSharpIcon from "@mui/icons-material/HelpOutlineSharp";
import Grid from "@mui/material/Grid";
import {s_app_mobile} from "../../_signals/s_app";

styled(Paper)(() => ({
    padding: "0px",
    textAlign: 'center',
}));

function Disciplines() {
    useSignals()

    const [add, setAdd] = useState(false)
    const [edit, setEdit] = useState('')
    const [hmAttr, setHMAttr] = useState('')

    const roll = (label: string, step: number) => {
        let step_mod = 0;
        if (hmAttr === 'str') step_mod = s_char_mods_str.value
        if (hmAttr === 'ges') step_mod = s_char_mods_ges.value
        if (hmAttr === 'zae') step_mod = s_char_mods_zae.value
        if (hmAttr === 'cha') step_mod = s_char_mods_cha.value
        if (hmAttr === 'wah') step_mod = s_char_mods_wah.value
        if (hmAttr === 'wil') step_mod = s_char_mods_wil.value
        const roll: IRollerRoll = {
            title: label,
            step: step,
            attribute: hmAttr,
            step_mod: 0,
            canusekarma: true,
            karma: false,
            strain: 0,
            vsnum: 0,
            vs:'',
            as: '',
            as_fix: true,
            target: [],
            targetVS: ''
        }

        rollerSetRoll(roll, true);
    }

    const handleInfoPopOpen = (name: string, e: SyntheticEvent) => {
        const discipline = DisciplinesSubscriber.value.find((d) => d.name === name)
        if (discipline) {
            InfoDisciplineBehaveSubscriber.next({popOpen: true, popEl: e.currentTarget, pop: discipline})
        }
    }

    const disciplineRow = (row: ICharDiscipline) => {

        const diszipline = disziplinen.find(d => d.name === row.name)

        return <TableRow key={row.id}>
            <TableCell style={{width: '79%'}}>
                <Stack spacing={2} direction="row" justifyContent="space-between">
                    <span>{row.name}</span>
                    <span>
                        {row.num === 1 ? ' Erste ' : null}
                        {row.num === 2 ? ' Zweite ' : null}
                        {row.num === 3 ? ' Dritte ' : null}
                    </span>
                    <span>Kreis {row.circle}</span>
                    {row.name ?
                        <HelpOutlineSharpIcon fontSize={'small'}
                                              onClick={(e) => handleInfoPopOpen(row.name, e)}/>
                        : null
                    }
                </Stack>
                {diszipline ?
                    <div style={{marginLeft: 12, fontSize: 'small', fontStyle: 'italic'}}>{diszipline.halbmagie}</div>
                    : null}
            </TableCell>
            <TableCell style={{width: '10%'}}>
                {row.circle >= 0 ? <Stack direction={'row'} justifyContent="space-between" alignItems="baseline">
                    <Button className={'btn'} size="small" onClick={() => setEdit(row.id)}>
                        <EditIcon/>
                    </Button>
                    <FormControl variant="standard" style={{width: '100%'}}>
                        <InputLabel id="dialog-attribute-label">Halbmagie</InputLabel>
                        <Select value={hmAttr || ''}
                                labelId="dialog-attribute-label"
                                variant="standard"
                                renderValue={(selected) => {
                                    return CharCreate.attributes.filter(a => a.pfield === selected.toString()).shift()?.tt;
                                }}
                        >
                            {CharCreate.attributes.map(a =>
                                <MenuItem key={v4()}
                                          value={a.pfield}
                                          onClick={(e) => setHMAttr(a.pfield)}>
                                    {a.tt}
                                </MenuItem>)}
                        </Select>
                    </FormControl>

                    <Button className={'btn'} size="small" disabled={!hmAttr}>
                        <CasinoOutlinedIcon
                            style={{margin: 10}}
                            onClick={() => roll('Halbmagie ' + row.name, row.circle)}/>
                    </Button>
                </Stack> : null}
            </TableCell>

        </TableRow>
    }

    return <Paper style={{overflowX: 'auto', marginTop: "14px"}}>
        <h3 style={{margin: "5px", display: 'flex', justifyContent: 'space-between'}}>
            <span>Disziplinen</span>
            <AddIcon onClick={() => setAdd(true)}/>
        </h3>
        <TableContainer style={{maxHeight: s_app_mobile.value ? 185 : '100%'}}>
            <Table stickyHeader style={{width: '100%'}}>
                <TableBody>{s_char_disciplines.value.map((row) => disciplineRow(row))}</TableBody>
            </Table>
        </TableContainer>
        <DisziplinesAdd open={add} isOpen={setAdd}></DisziplinesAdd>
        <DisziplinesEdit edit={edit} isOpen={(e) => setEdit(e)}></DisziplinesEdit>
    </Paper>
}

export default Disciplines;
